'use client';

import React, { useRef } from 'react';
import Image from 'next/image';
import { gsap, ScrollTrigger, useGSAP, MOTION_OK } from '@/components/motion/gsap';

const partners = [
  { src: '/images/img_image_18.png', alt: 'VisionWeb' },
  { src: '/images/img_image_19.png', alt: 'Santinelli' },
  { src: '/images/img_image_20.png', alt: 'Partner 3' },
  { src: '/images/img_image_21.png', alt: 'Satisloh' },
  { src: '/images/img_image_22.png', alt: 'Partner 5' },
  { src: '/images/img_image_23.png', alt: 'Partner 6' },
];

const PartnerLogos = () => {
  // duplicate the list so the track can loop seamlessly at translateX(-50%)
  const loop = [...partners, ...partners];
  const root = useRef(null);

  // The belt drifts on its own and takes its speed from the scroll: flick the
  // page and it surges and leans into it, then eases back to the idle drift.
  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        const belt = root.current.querySelector('[data-belt]');
        const setX = gsap.quickSetter(belt, 'xPercent');
        const setSkew = gsap.quickSetter(belt, 'skewX', 'deg');
        const st = ScrollTrigger.create({
          trigger: root.current,
          start: 'top bottom',
          end: 'bottom top',
        });
        let x = 0;
        let boost = 0;
        let hover = false;
        const enter = () => (hover = true);
        const leave = () => (hover = false);
        root.current.addEventListener('pointerenter', enter);
        root.current.addEventListener('pointerleave', leave);
        const tick = (_, delta) => {
          if (!st.isActive) return;
          const v = gsap.utils.clamp(-4000, 4000, st.getVelocity());
          boost += (Math.abs(v) / 400 - boost) * 0.08;
          const idle = hover ? 0 : 1;
          x -= (delta / 1000) * 1.45 * (idle + boost);
          if (x <= -50) x += 50;
          setX(x);
          setSkew(gsap.utils.clamp(-6, 6, -v / 500) * Math.min(1, boost));
        };
        gsap.ticker.add(tick);
        return () => {
          gsap.ticker.remove(tick);
          root.current?.removeEventListener('pointerenter', enter);
          root.current?.removeEventListener('pointerleave', leave);
        };
      });
      return () => mm.revert();
    },
    { scope: root }
  );

  return (
    <section ref={root} className="pb-12 pt-10">
      {/* The logo files are transparent PNGs, and the edges fade with a mask
          rather than a coloured overlay, so the belt sits on any backdrop. */}
      <div className="group relative overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_10%,#000_90%,transparent)]">
        <div data-belt className="flex w-max items-center will-change-transform">
          {loop.map((partner, index) => (
            <div key={index} className="flex shrink-0 items-center justify-center px-8 sm:px-12">
              <Image
                src={partner.src}
                alt={partner.alt}
                width={202}
                height={106}
                className="h-12 w-auto object-contain transition duration-300 hover:scale-105 sm:h-14"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerLogos;
